export default __webpack_public_path__ + "static/media/Foto-03.5d945865.png";